import { gql } from '@apollo/client';

import {
  SurveyCompletionStatusDocument,
  type SurveyCompletionStatusQuery,
  type SurveyCompletionStatusQueryVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    query SurveyCompletionStatus($insightId: UUID!) {
      surveyCompletionStatus(insightId: $insightId) {
        missingRequiredQuestions {
          id
          text
          translatedText
          type
          required
          questionOrder
        }
      }
    }
  `;
}

export const SURVEY_COMPLETION_STATUS = SurveyCompletionStatusDocument;
export type {
  SurveyCompletionStatusQuery,
  SurveyCompletionStatusQueryVariables,
};
